import {
  TimePicker as KendoTimePicker,
  TimePickerChangeEvent,
  TimePickerProps,
} from '@progress/kendo-react-dateinputs';
import _ from 'lodash';
import { ValidationError } from '../../apps/benefit/models/Errors';
import { config } from '../global/config';
import ErrorViewer from './ErrorViewer';

interface ITimePickerProps {
  controlClassName?: string;
  mandatory?: boolean;
  helper?: string;
  onChange?: (e: TimePickerChangeEvent) => void;
  errors?: ValidationError[];
  clearErrors?: () => void;
}

const TimePicker = (props: ITimePickerProps & TimePickerProps) => {
  const {
    controlClassName,
    mandatory,
    helper,
    id,
    label,
    errors,
    onChange,
    clearErrors,
  } = props;
  const internalOnChange = (e: TimePickerChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };

  const classNames = `control-group ${controlClassName ?? ''} ${
    errors ? 'control-error' : ''
  }`.trim();

  const popupSettings = {
    ...props.popupSettings,
    popupClass: `k-timepicker-popup app-time-picker-popup ${
      props.popupSettings?.popupClass ?? ''
    }`.trim(),
  };

  return (
    <div className={classNames}>
      <div className="control-content">
        {!!label && (
          <label htmlFor={id}>
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoTimePicker
          {..._.omit(props, 'label')}
          id={id}
          popupSettings={popupSettings}
          onChange={internalOnChange}
        />
      </div>
      {!!helper && <div className="control-info">{helper}</div>}
      <ErrorViewer errors={errors} />
    </div>
  );
};

TimePicker.defaultProps = { format: config.timeFormat };

export default TimePicker;
